import { Component } from "react";
import { Context } from "common/types/context";
import { Entity } from "common/entities/types";
import { getLocalizedName } from "common";
import { searchApi } from "common/api/search";
import { Query } from "common/query/types";
import { ActionButton } from "common/ui/buttons";
import "./parts-to-be-counted.scss";

interface PropTypes {
  context: Context;
  entity: Entity;
  cycleCountId: string;
  isDirty: boolean;
  query: Query;
}

export class PartsExportAction extends Component<PropTypes> {
  static readonly displayName = "PartsExportAction";

  onClick = () => {
    const { context, entity, cycleCountId, query } = this.props;
    const entityName = entity.name;
    const updatedQuery: Query = {
      ...query,
      filter: {
        and: [
          {
            name: "cycleCountId",
            op: "eq",
            value: cycleCountId,
          },
        ],
      },
    };

    return searchApi(context.apiCall).downloadCsv(
      getLocalizedName(entity),
      { entity: entityName, query: updatedQuery },
      context.site.name,
    );
  };

  render() {
    const { isDirty } = this.props;
    return (
      <div className="x-part-export-action">
        <ActionButton
          title={_("Export")}
          onClick={this.onClick}
          disabled={isDirty}
        >
          {_("Export List To Csv")} <i className="fa fa-download" />
        </ActionButton>
      </div>
    );
  }
}
